import { render, staticRenderFns } from "./CallbackPage.vue?vue&type=template&id=4f8a5004&"
import script from "./CallbackPage.vue?vue&type=script&lang=js&"
export * from "./CallbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports